{
  "archived_Desc_Key": "Tu peux trouver plus d’aide ici.",
  "archived_Title_Key": "Ce document a été archivé.",
  "carousel_Text_Key": "Cet article ne t'a pas aidé ? Jette un œil aux articles similaires ci-dessous.",
  "clear_button_label_Text_Key": "Effacer le champ de recherche",
  "click_prompt_Text_Key": "cliquez ici",
  "close_Text_Key": "Fermer",
  "customerService_Text_Key": "Service clientèle",
  "error_Text_Key": "Une erreur s'est produite.",
  "faq": "Foire aux questions",
  "feedback_Option1_Text_Key": "Le texte manque de clarté",
  "feedback_Option2_Text_Key": "Le texte ne répond pas à ma question",
  "feedback_Option3_Text_Key": "Le texte est pertinent, mais ne m'a pas été utile",
  "feedback_Option4_Text_Key": "Le texte est trop long ou trop court ",
  "feedback_Question_1_Text_Key": "Quelles parties spécifiques de nos articles trouvez-vous décevantes ou inutiles ?",
  "feedback_Rec_Text_Key": "Merci pour ton feedback !",
  "feedback_Text_Key": "Est-ce que cette information était utile ?",
  "here_Text_Key": "ici",
  "knowledge_Text_Key": "Base de connaissance",
  "link_prod_error_Text_Key": "https://ikea.marat.qd.je/be/fr/customer-service/track-manage-order/",
  "loading_Text_Key": "Chargement en cours",
  "market_Name_Key": "Belgique",
  "modal_button_Close_Text_Key": "Fermer",
  "negative_feedback_Text_Key": "Nous sommes désolés que vous n'ayez pas trouvé la réponse à votre question. Souhaitez-vous nous aider à améliorer notre service ?",
  "no_results_Text_Key": "Nous ne trouvons aucun résultat pour: {{query}}",
  "product_error_Text_Key": "Vous cherchez un produit ? Merci d'utiliser le moteur de recherche situé en haut de page. Si vous souhaitez suivre l'état d'avancement de votre commande, c'est par",
  "read_more_button_Text_Key": "En savoir plus",
  "results_Text_Key": "Nous avons trouvé {{number}} résultats pour: {{query}}",
  "retrieving_Text_Key": "Récupération",
  "search_button_label_Text_Key": "Rechercher",
  "searchbar_Text_Key": "Écris un mot ou une phrase, par exemple \"commander\" ou \"modifier\".",
  "searching_Text_Key": "Recherche en cours…",
  "showLess_Text_Key": "Afficher moins",
  "showMore_Text_Key": "Afficher plus",
  "spellcheck_Text_Key": "Essayez avec une autre orthographe ou d'autres mots-clés.",
  "submit_Text_Key": "Envoyer",
  "try_again_Text_Key": "Réessaie plus tard"
}